import {all} from 'redux-saga/effects';
import DashboardSagas from './Dashboard/saga';
import ListSagas from './List/saga';
import ContactSagas from './Contact/saga';
import ProductSagas from './Product/saga';
import ProductBundleSagas from './ProductBundle/saga';
import ProductGroupSagas from './ProductGroup/saga';
import TermSagas from './Term/saga';
import CurrencySagas from './Currency/saga';
import ReportSagas from './Report/saga';
import AccountSagas from './Account/saga';
import BankAccountSagas from './BankAccount/saga';
import TransactionSagas from './Transaction/saga';
import PublicTransactionSagas from './PublicTransaction/saga';
import PublicStatementSagas from './PublicStatement/saga';
import InstructionSagas from './Instruction/saga';
import SettingSagas from './Setting/saga';
import CompanySagas from './Company/saga';
import UserSagas from './User/saga';
import AccessSagas from './Access/saga';
import SearchSagas from './Search/saga';
import AuthSagas from './Auth/saga';
import ShoeboxSagas from './Shoebox/saga';
import ShoeboxTransactionSagas from './ShoeboxTransaction/saga';
import PartnerSagas from './Partner/saga';
import SubscriptionSagas from './Subscription/saga';
import CouponSagas from './Coupon/saga';
import PlanSagas from './Plan/saga';
import OpeningSagas from './Opening/saga';
import BatchInvoicingSagas from './BatchInvoicing/saga';
import ImportSagas from './Import/saga';
import TagSagas from './Tag/saga';
import AnnotationSagas from './Annotation/saga';
import TestSagas from './Test/saga';
import GroupSagas from './ContactGroup/saga';
import ReconciliationSagas from './Reconciliation/saga';
import ExtensionSagas from './Extension/saga';
import AssetSagas from './Asset/saga';
import LocationSagas from './Location/saga';
import FieldSagas from './Field/saga';
import NumberFormatSagas from './NumberFormat/saga';
import StockBalanceSagas from './StockBalance/saga';
import AuditSagas from './Audit/saga';
import EditableTableSagas from './EditableTable/saga';
import FileSagas from './File/saga';
import NotificationSagas from './Notification/saga';
import ContactAddressSagas from './ContactAddress/saga';
import StoreSagas from './Store/saga';
import StoreSettingSagas from './StoreSetting/saga';
import PaymentMethodSagas from './PaymentMethod/saga';
import LocalStorageSagas from './LocalStorage/saga';
import PriceLevelSagas from './PriceLevel/saga';
import FormDesignSagas from './FormDesign/saga';
import PayrollSagas from './Payroll/saga';
import PublicListSagas from './PublicList/saga';
import BackupSagas from './Backup/saga';
import TransactionTransferSagas from './TransactionTransfer/saga';
import LoggerSagas from './Logger/saga';
import LightboxSagas from './Lightbox/saga';
import QuotaSagas from './Quota/saga';
import BankFeedSagas from './BankFeed/saga';
import FinancingSagas from './Financing/saga';
import FlowSagas from './Flow/saga';
import AuditModuleSagas from './AuditModule/saga';
import ContactMyinvoisDataSagas from './ContactMyinvoisData/saga';
import OtpSagas from './Otp/saga';
import MyInvoisSagas from './MyInvois/saga';
import AiSagas from './Ai/saga';
import PublicMiniPosOrderSagas from './PublicMiniPosOrder/saga';
import MiniPosSagas from './MiniPos/saga';
import AppCpSagas from './AppCp/saga';
import BukkuAdminSagas from './BukkuAdmin/saga';
import PublicPricingTransitionSagas from './PublicPricingTransition/saga';

export default function* rootSaga() {
    yield all([
        DashboardSagas(),
        ListSagas(),
        ContactSagas(),
        ProductSagas(),
        ProductBundleSagas(),
        ProductGroupSagas(),
        TermSagas(),
        CurrencySagas(),
        ReportSagas(),
        AccountSagas(),
        BankAccountSagas(),
        TransactionSagas(),
        PublicTransactionSagas(),
        PublicStatementSagas(),
        InstructionSagas(),
        SettingSagas(),
        CompanySagas(),
        UserSagas(),
        AccessSagas(),
        SearchSagas(),

        AuthSagas(),
        ShoeboxSagas(),
        ShoeboxTransactionSagas(),
        PartnerSagas(),
        SubscriptionSagas(),
        CouponSagas(),
        PlanSagas(),
        OpeningSagas(),
        BatchInvoicingSagas(),
        ImportSagas(),
        TagSagas(),
        AnnotationSagas(),
        TestSagas(),
        GroupSagas(),
        ReconciliationSagas(),
        ExtensionSagas(),
        AssetSagas(),
        FieldSagas(),
        NumberFormatSagas(),
        AuditSagas(),

        LocationSagas(),
        StockBalanceSagas(),
        EditableTableSagas(),
        FileSagas(),
        NotificationSagas(),
        ContactAddressSagas(),
        StoreSagas(),
        StoreSettingSagas(),
        PaymentMethodSagas(),
        PriceLevelSagas(),
        FormDesignSagas(),
        PayrollSagas(),
        PublicListSagas(),
        BackupSagas(),
        LocalStorageSagas(),
        TransactionTransferSagas(),
        LoggerSagas(),
        LightboxSagas(),
        QuotaSagas(),
        BankFeedSagas(),
        FinancingSagas(),
        FlowSagas(),
        AuditModuleSagas(),
        ContactMyinvoisDataSagas(),
        OtpSagas(),
        MyInvoisSagas(),
        AiSagas(),
        PublicMiniPosOrderSagas(),
        MiniPosSagas(),
        AppCpSagas(),
        BukkuAdminSagas(),
        PublicPricingTransitionSagas(),
    ]);
}
